<!--
 * @Author: ryt_lijun qisui_jun@163.com
 * @Date: 2022-10-26 09:52:41
 * @LastEditors: bianbinbin
 * @LastEditTime: 2026-06-29 11:17:20
 * @FilePath: /ejx-web/src/App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
import { registerArray } from '@/constant'
import store from '@/store'

export default {
  created() {
    this.$native.api.setBounces([false]) // 设置禁止ios弹动
    for (const v of registerArray) {
      this.$native.registerApi('MideaCommon', v) // 注册原生事件
    }
    this.$native.api.judgeSystem().then(res => {
      const formatRes = typeof res === 'string' ? JSON.parse(res || '{}') : res
      store.dispatch('setIsIos', formatRes?.type === '1')
    })
    this.$native.api.statusBarColor([255, 255, 255, 1])
  }
}
</script>

<style lang="scss"></style>
